export default __webpack_public_path__ + "static/0272-6bfad879014b5fa6fbc074e568397a16.png";